import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { UserProvider, useUser } from './pages/UserContext';
import AuthNavbar from './pages/AuthNavbar';
import HomePage from './pages/HomePage';
import FirmenList from './pages/FirmenList';
import RegistrationForm from './pages/RegistrationForm';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import AdminDashboard from './pages/AdminDashboard';
import PrivateFirmenList from './pages/PrivateFirmenList';
import CreatePrivateFirma from './pages/CreatePrivateFirma';
import EditFirma from './pages/EditFirma';
import Datenschutzerklärung from './pages/Datenschutzerklärung';
import AdminPage from './pages/AdminPage';
import './pages/global.css';

// URL Cleanup Component
function URLCleanup() {
  useEffect(() => {
    // Only clean up if there's a hash in the URL
    const cleanupURL = () => {
      if (window.location.hash) {
        window.history.replaceState(null, '', window.location.pathname + window.location.search);
      }
    };

    // Clean up on initial load
    cleanupURL();
    
    // Clean up on hash changes
    const handleHashChange = () => {
      cleanupURL();
    };
    
    window.addEventListener('hashchange', handleHashChange);
    
    return () => {
      window.removeEventListener('hashchange', handleHashChange);
    };
  }, []);

  return null;
}

// Protected Route Component
function ProtectedRoute({ children, roles }) {
  const { user } = useUser();
  const location = useLocation();
 
  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
 
  if (roles && !roles.includes(user.rolle)) {
    return <Navigate to="/" replace />;
  }
 
  return children;
}

function App() {
  return (
    <UserProvider>
      <Router>
        <URLCleanup />
        <div className="app-container">
          <AuthNavbar />
          <main className="main-content">
            <div className="page-container">
              <Routes>
                {/* Public routes */}
                <Route path="/" element={<HomePage />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/register" element={<RegisterPage />} />
                <Route path="/Datenschutzerklärung" element={<Datenschutzerklärung />} />
               
                {/* Public firma routes */}
                <Route path="/firma/register" element={<RegistrationForm />} />
                <Route path="/firmen-list" element={<FirmenList />} />
                <Route path="/edit-firma/:id" element={<EditFirma />} />
                
                {/* Protected routes - Admin only */}
                <Route
                  path="/dashboard"
                  element={
                    <ProtectedRoute roles={['ADMIN']}>
                      <AdminDashboard />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/admin/public-list"
                  element={
                    <ProtectedRoute roles={['ADMIN']}>
                      <AdminPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/admin/create-private-firma"
                  element={
                    <ProtectedRoute roles={['ADMIN']}>
                      <CreatePrivateFirma />
                    </ProtectedRoute>
                  }
                />
                
                {/* Protected routes - Admin and Teacher */}
                <Route
                  path="/private-firmen"
                  element={
                    <ProtectedRoute roles={['ADMIN', 'TEACHER']}>
                      <PrivateFirmenList />
                    </ProtectedRoute>
                  }
                />
                
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </div>
          </main>
        </div>
      </Router>
    </UserProvider>
  );
}

export default App;